<template>
  <el-container style="height: 100%">
    <el-header height="60px">
      <Header></Header>
    </el-header>
    <el-container>
      <Aside></Aside>
      <el-main>
        <breadcrumb v-show="showBreadcrumb"></breadcrumb>
        <div :style="{'height': showBreadcrumb ? `calc(100% - 30px)` : '100%' }">
          <keep-alive :include="cacheViews">
            <router-view :key="viewKey" v-if="$route.meta.keepAlive"></router-view>
          </keep-alive>
          <router-view :key="viewKey" v-if="!$route.meta.keepAlive"></router-view>
        </div>
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
import Header from './header.vue';
import Aside from './aside.vue';
import breadcrumb from './breadcrumb.vue';
import { useTagViewStore } from '@/pinia/tagView';
import { useMapStore } from '@/pinia/map';

export default {
  name: 'layout',
  components: {
    Header,
    Aside,
    breadcrumb,
  },
  data() {
    return {
      wrapperComMap: new Map()
    }
  },
  computed: {
    showBreadcrumb() {
      return this.$route.meta && this.$route.meta.showBreadcrumb;
    },
    viewKey() {
      return this.$route.path;
    },
    cacheViews() {
      return useTagViewStore().cacheViews;
    },
  },
  watch: {
    cacheViews(newVal) {
      console.log('cacheViews 改变', newVal);
    },
  },
  created() {
    // 动态引入天地图
    useMapStore().loadMap();
  }
}
</script>

<style scoped>
.fade-enter {
  visibility: hidden;
  opacity: 0;
}

.fade-leave-to {
  display: none;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity .5s ease;
}

.fade-enter-to,
.fade-leave {
  visibility: visible;
  opacity: 1;
}
</style>



// WEBPACK FOOTER //
// src/layout/index.vue